import type { Schemas } from "#shopware";

type ListingFilter = {
    label: string;
    code: string;
    id: string;
    name: string;
};

export function isFilterNotEmpty(filter: ListingFilter): boolean {
  // Check if neither 'entities' nor 'options' are present
  if (!filter.hasOwnProperty('entities') && !filter.hasOwnProperty('options')) {
    return true;
  }
  
  // Check if 'entities' exists and is a non-empty array
  if (filter.hasOwnProperty('entities') && Array.isArray(filter.entities) && filter.entities.length > 0) {
    return true;
  }
  
  // Check if 'options' exists and is a non-empty array
  if (filter.hasOwnProperty('options') && Array.isArray(filter.options) && filter.options.length > 0) {
    return true;
  }
  
  // If 'entities' or 'options' exists but is an empty array, return false
  return false;
}

export function isAddressValid(address: Schemas['CustomerAddress'] | null): boolean {
	if (!address) {
		return false
	}

	if (address.city === '-' || address.street === '-' || address.zipcode === '-') {
		return false
	}

	const { street, city, zipcode } = address
	return Boolean(street?.trim() && zipcode?.trim() && city?.trim())
}

export function deepEqual(obj1: Record<any, any>, obj2: Record<any, any>) {
    if (obj1 === obj2) return true;
    if (obj1 == null || typeof obj1 !== "object" || obj2 == null || typeof obj2 !== "object") {
        return false;
    }
    let keys1 = Object.keys(obj1), keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for (let key of keys1) {
        if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) return false;
    }
    return true;
}

export function getFormattedPrice(price: number | undefined) {
  const _price = price || 0;
  
  return new Intl.NumberFormat('lt-LT', {
    style: "currency",
    currency: 'EUR',
  }).format(+_price)
}

export const getCanonicalUrl = (seoResult: Ref<Schemas['SeoUrl'] | null>): string | undefined => {
	if (seoResult?.value?.isCanonical && !seoResult?.value?.isDeleted) {
		return seoResult?.value?.seoPathInfo ?? ''
	}

	return undefined
}
